module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_02-d7dca73e3033b4de0fb4db15fe018919.jpg";